import { Row,Col,Image,Stack, Button } from 'react-bootstrap';
import { ICONS } from 'Utils/icons';


function NavigationBar({ 
    setShowFloatingDropdown, 
    showFloatingDropdown, 
    resultIndex, 
    totalResults, 
    changeResultIndex, 
    itemLocation, 
    setIsFocusBase, 
    setHasFocus, 
    hasFocus,
    setOpenBtnFocus,
    setSearchBarFocus,
    setSearchBtnFocus ,
    openBtn,
    searchBar,
    searchBtn

}) {
    const handleFocusLocation = () => {
        if(itemLocation=='fixed'){
            setIsFocusBase(false);
        }
        else{
            setIsFocusBase(true);
        }
    }

    return (
        <div id="ct-search-nav-test" className="d-flex flex-row justify-content-between  align-items-center small py-2 px-2 bg-color-base-lightgray ">
            <div className="pagination">
                <Button 
                    ref={openBtn}
                    className="rounded-0 bg-color-base-white color-base-darkgray"
                    onClick={()=>{
                        setShowFloatingDropdown(!showFloatingDropdown);
                    }}
                    onFocus={(e) => {
                        //console.log(e);
                        handleFocusLocation();
                        setHasFocus(true);
                        setOpenBtnFocus(true);
                    }}
                    onBlur={(e) => {
                        //console.log("blur",e);
                        setHasFocus(false);
                        setOpenBtnFocus(false);
                    }}
                    //autoFocus={hasFocus}
                    title={showFloatingDropdown==true ?  "Close search results" : "Open search results"}
                >
                    <div>
                        {showFloatingDropdown==true ? ICONS.hamburgerOpen() : ICONS.hamburger() }
                        <span class="visually-hidden">Open</span>
                    </div>
                </Button>
            </div>
            <div className="d-flex flex-row align-items-center gap-3">
                <p className="mb-0 d-block body semibold">Result {resultIndex} of {totalResults}</p>
                <div className="pagination d-flex gap-2">
                    <Button 
                        title="Go to previous search result"
                        disabled={totalResults==0}
                        className="rounded-0 bg-color-base-white color-base-darkgray"
                        onClick={()=>{
                            changeResultIndex(-1);
                        }}
                    >
                        <div>
                            {ICONS.upCaret()}
                            <span class="visually-hidden">Previous</span>
                        </div>
                    </Button>
                    <Button 
                        title="Go to next search result"
                        disabled={totalResults==0}
                        className="rounded-0 bg-color-base-white color-base-darkgray"
                        onClick={()=>{
                            changeResultIndex(1);
                        }}
                    >
                        <div>
                            {ICONS.downCaret()}
                            <span class="visually-hidden">Next</span>
                        </div>
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default NavigationBar;